define('bindingHandlers/dragDropBlock',[
    'lib/lodash4',
    'lib/knockout',
    'jquery'
], function (_, ko, $) {
    'use strict';

    var NAMESPACE = '.dragDropBlock';

    /**
     * Drag/drop block blocks the default action of dragging anything into the window.  This is helpful when using
     * drag/drop behavior to drag items into an area - but keep the drop from causing the browser to attempt to open
     * the dropped in files.
     */
    ko.bindingHandlers.dragDropBlock = {
        init: function (element) {
            var onBodyDragDrop = function(event) {
                    event.preventDefault();
                    return false;
                };

            $(document.body)
                .on('dragenter' + NAMESPACE, onBodyDragDrop)
                .on('drop'      + NAMESPACE, onBodyDragDrop)
                .on('dragover'  + NAMESPACE, onBodyDragDrop);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(document.body).off(NAMESPACE);
            });
        }
    };
});

